interface Window { dataLayer: any[] }

type StepName = 'journeys' | 'estimate' | 'account' | 'synch' | 'no-account' | 'unsure' | 'success' | 'unsuccess';

declare var links: { [name: string]: { url: string, path: string, title: string } },
    journeyBrackets: { name: string, amount: string }[],
    urlPathPrefix: string,
    steps: { [step: string]: { urlPath: string, title: string, tab: number } },
    apiDomain: string;

interface JQueryStatic {
    cookie(name: string, value: string, opts?: { expires: number }): void;
    cookie(name: string): string;
    removeCookie(name: string): boolean;
}

namespace tflForm {

    interface BlueOnSelect extends JQuery {
        blueSelect(handler: (ev: JQueryEventObject, d: { val: string }) => any): JQuery
    }

    let emailRegex = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, $ = jQuery;

    $.fn.blueSelect = function (func: (ev: JQueryEventObject, d: { val: string }) => any) {
        this.on('blueSelect', func);
    }

    $(function () {
        window.dataLayer = window.dataLayer || [];

        let $stepGsW = $('.steps-g'), $stepGs = $stepGsW.children('.step-g'),
            $stepsW = $('#steps'), $steps = $stepsW.children('.step'),
            initSteps = {},
            email: string,
            journeysIX: number,
            $htmlBody = $('html,body'),
            curStep: string | undefined;

        //navigation
        function gotoStep(step: StepName, noHistory: boolean = false, extraPushData?: any) {
            $('#step-' + step).addClass('active').siblings('.step').removeClass('active');
            $stepGs.eq(steps[step].tab).addClass('active').siblings().removeClass('active');
            if (curStep)
                $htmlBody.scrollTop(window.innerWidth <= 1100 ? 60 : 50);
            if (!noHistory)
                history.pushState({ step: step }, '');
            let pushData = $.extend({
                'virtualPageviewPage': urlPathPrefix + steps[step].urlPath,
                'virtualPageviewTitle': steps[step].title,
                'step': step,
                'event': 'loadStep',
                'previousStep': curStep
            }, extraPushData);
            if (step == 'estimate') {
                pushData['number-journeys'] = journeyBrackets[journeysIX].name;
                pushData['refund-estimate'] = journeyBrackets[journeysIX].amount;
            }
            window.dataLayer.push(pushData);
            curStep = step;
        }
        (<any>window).gotoStep = gotoStep;

        window.onpopstate = function (ev) {
            if (ev.state)
                gotoStep(<StepName>ev.state.step, true);
        };

        //step journeys
        (function () {
            let $numJourneysW = <BlueOnSelect>$('#num-journeys'), $form = $('#step-journeys-form');
            $.each(journeyBrackets, function (i, journeyBracket) {
                $numJourneysW.append($('<div>', { class: 'item', 'data-val': i }).text(journeyBracket.name));
            });
            $numJourneysW.blueSelect(function (ev, d) {
                journeysIX = +d.val;
                $.cookie('journeysIX', d.val);
                initEstimate();
                gotoStep('estimate');
            });
        })();

        //step estimate
        let initEstimate: () => void, setEmailFromCookie: (_email: string) => void;
        (function () {
            let $form = $('#step-estimate-form'), $ifYouTravel = $('.if-you-travel', $form),
                $estimate = $('.estimate', $form), $email = $('.email', $form), $confEmail = $('.conf-email', $form),
                $next = $('.next', $form), $back = $('.back', $form), emailValid = false, confEmailValid = false, submitted = false,
                $yourEmail = $('#your-email');
            function validateEmail() {
                let val = $email.val(), show = val.length > 0 || submitted;
                emailValid = emailRegex.test(val);
                $email.parent().toggleClass('err', !emailValid && show).toggleClass('ok', emailValid && show);
            }
            function validateConfEmail() {
                let val = $confEmail.val(), show = val.length > 0 || submitted;
                confEmailValid = $email.val() == val;
                $confEmail.parent().toggleClass('err', !confEmailValid && show).toggleClass('ok', confEmailValid && show);
            }
            function nextEnable() {
                $next.prop('disabled', !emailValid || !confEmailValid);
            }
            function validate() {
                validateEmail();
                validateConfEmail();
                nextEnable();
            }
            $back.click(function () {
                history.back();
            });
            $email.add($confEmail).on('input', validate);
            $form.submit(function () {
                submitted = true;
                validate();
                if (emailValid && confEmailValid) {
                    email = $email.val();
                    $.cookie('email', btoa(email));
                    $.post('//' + apiDomain + '/api/lead', {
                        email: email, journeys: journeyBrackets[journeysIX].name, affiliateID: $.cookie('affiliateID'), referrer: $.cookie('referrer')
                    }).then((r: { id: number, brandNew: boolean }) => window.dataLayer.push({
                        event: 'leadIDReturned',
                        leadID: r.id,
                        leadAffStatus: r.brandNew ? 1 : 0
                    }));
                    $yourEmail.hide();
                    gotoStep('account');
                }
                return false;
            });
            initEstimate = function () {
                //$ifYouTravel.text(quotes[numJourneys][0]);
                $estimate.html('&pound;' + journeyBrackets[journeysIX].amount + '*');
            }
            setEmailFromCookie = function (_email: string) {
                email = _email;
                $email.add($confEmail).val(email);
                $yourEmail.show();
                $yourEmail.children('.email').text(email);
                $yourEmail.children('.not-you').click(function () {
                    $.removeCookie('journeysIX');
                    $.removeCookie('email');
                    $email.add($confEmail).val('');
                    $yourEmail.hide();
                    validate();
                    gotoStep('journeys');
                });
                validate();
            }
            validate(); //if browser had prepopulated fields
        })();

        //step account
        (function () {
            let $form = $('#step-account-form'), $btnsW = <BlueOnSelect>$form.find('>.inner>.btns'),
                $back = $('.back', $form);
            $btnsW.blueSelect(function (ev, d) {
                $.post('//' + apiDomain + '/api/lead', { email: email, hasAccount: d.val });
                switch (d.val) {
                    case 'yes': gotoStep('synch'); break;
                    case 'no': gotoStep('no-account'); break;
                    case 'unsure': gotoStep('unsure'); break;
                }
            })
            $back.click(function () {
                history.back();
            });
        })();

        //step synch
        (function () {
            let $form = $('#step-synch-form'), $username = $('.username', $form), $pwd = $('.pwd', $form), $terms = $('.terms-chk', $form),
                termsEl = <HTMLInputElement>$terms[0],
                $next = $('.next', $form), $back = $('.back', $form),
                usernameValid = false, pwdValid = false, submitted = false;

            function validateUsername() {
                let val = $username.val(), show = val.length > 0 || submitted;
                usernameValid = val.length > 2;
                $username.parent().toggleClass('err', !usernameValid && show).toggleClass('ok', usernameValid && show);
            }
            function validatePwd() {
                let val = $pwd.val(), show = val.length > 0 || submitted;
                pwdValid = val.length > 2;
                $pwd.parent().toggleClass('err', !pwdValid && show).toggleClass('ok', pwdValid && show);
            }
            function nextEnable() {
                $next.prop('disabled', !(usernameValid && pwdValid && termsEl.checked));
            }
            function validate() {
                validateUsername();
                validatePwd();
                nextEnable();
            }   
            $username.add($pwd).on('input', validate);
            $terms.click(nextEnable);
            $back.click(function () {
                history.back();
            });
            $form.submit(function () {
                submitted = true;
                validate();
                if (usernameValid && pwdValid && termsEl.checked) {
                    $next.html('Connecting <i class="fa fa-spinner fa-spin"></i>');
                    $next.add($username).add($pwd).add($terms).prop('disabled', true);
                    $.post('//' + apiDomain + '/api/credentials', { username: $username.val(), pwd: $pwd.val(), email: email }, function (r) {
                        if (r.success) {
                            $.removeCookie('journeysIX');
                            $.removeCookie('email');
                            initSuccess(r);
                            gotoStep('success', false, { userID: r.id });
                        }
                        else
                            gotoStep('unsuccess');
                    }).always(function () {
                        $next.text('Connect');
                        $next.add($username).add($pwd).add($terms).prop('disabled', false);
                    }).fail(function () {
                        alert('We could not connect right now, please try again soon.');
                    });
                }
                return false;
            });
            validate();
        })();

        //step no-account
        (function () {
            let $step = $('#step-no-account'), $back = $('.back', $step), $create = $('.create', $step), $registerLink = $('.register-link', $step);
            $back.click(function () {
                history.back();
            });
            $create.click(function () {
                openLink('register');
                history.back();
            });
            $registerLink.click(function () {
                history.back();
            });
        })();

        //step unsure
        (function () {
            let $step = $('#step-unsure'), $form = $step.children('.gray-form'), $btnsW = <BlueOnSelect>$form.find('>.inner>.btns'), $back = $('.back', $form);
            $btnsW.blueSelect(function (ev, d) {
                switch (d.val) {
                    case 'synch': gotoStep('synch'); break;
                    case 'reset': openLink('forgotUsername'); history.back(); break;
                    case 'create': openLink('register'); history.back(); break;
                }
            });
            $back.click(function () {
                history.back();
            });
        })();

        //step success
        interface SyncRes { success: boolean, existed: boolean, emailUpdated: boolean, id: number }
        let initSuccess: (res: SyncRes) => void;
        (function () {
            let $step = $('#step-success'), $close = $('.my-close', $step), $addCards = $('.add-cards', $step);
            $close.click(function () {
                location.href = '/';
            });
            $addCards.click(function () {
                openLink('addCards');
            });
            initSuccess = function (res) {}
        })();

        //step unsuccess
        (function () {
            let $step = $('#step-unsuccess'), $form = $step.children('.gray-form'), $btnsW = <BlueOnSelect>$form.find('>.inner>.btns'), $back = $('.back', $form);
            $btnsW.blueSelect(function (ev, d) {
                switch (d.val) {
                    case 'synch': gotoStep('synch'); break;
                    case 'reset': openLink('forgotUsername'); history.back(); break;
                    case 'create': openLink('register'); history.back(); break;
                }
            });
            $back.click(function () {
                history.back();
            });
        })();

        //blue-on-select
        $('.blue-on-select').each(function () {
            let $w = $(this), $items = $w.find('.item');
            $items.click(function () {
                let $this = $(this);
                //$this.addClass('active').siblings('.item').removeClass('active');
                $w.trigger('blueSelect', { val: $this.attr('data-val') });
            });
        });

        //url links
        $('[data-url]').click(function () {
            let url = $(this).attr('data-url');
            openLink(url);
        });

        function openLink(linkName: string) {
            open('/redirector?link=' + linkName);
        }

        //start
        history.replaceState({ step: 'journeys' }, '');
        let cookieJourneysIX = $.cookie('journeysIX'), firstStep: StepName;
        if (cookieJourneysIX) {
            journeysIX = +cookieJourneysIX;
            initEstimate();
            let cookieEmail = $.cookie('email'), _email: string | undefined;
            if (cookieEmail)
                _email = atob(cookieEmail);
            if (_email && emailRegex.test(_email)) {
                setEmailFromCookie(_email);
                history.pushState({ step: 'estimate' }, '');
                firstStep = 'account';
            }
            else
                firstStep = 'estimate';
        }
        else
            firstStep = 'journeys';
        gotoStep(firstStep, firstStep == 'journeys');
    });
}
